import { i18nNsFactory } from '@atlas-frontend/i18n';
import type { FC, PropsWithChildren, ReactNode } from 'react';
import { Flex } from 'antd';
import styled from 'styled-components';
import {
  Modal,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '../../../../common/components';
import { FormAlerts } from '../../../../common/form';
import translations from './AlgorithmJoinsWithMappingsGraphModal.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithm-joins-with-mappings-graph-modal',
);
addTranslations(translations);

export interface AlgorithmJoinsWithMappingsGraphModalProps
  extends PropsWithChildren {
  onClose?: () => void;
  actions?: ReactNode;
  footer?: ReactNode;
  transition?: boolean;
  afterOpenChange?: (open: boolean) => void;
  readOnly?: boolean;
}

export const AlgorithmJoinsWithMappingsGraphModal: FC<
  AlgorithmJoinsWithMappingsGraphModalProps
> = (props) => {
  const { t } = useTranslation();
  const {
    onClose,
    actions = t('joins-and-mappings'),
    footer,
    transition = true,
    afterOpenChange,
    readOnly,
    children,
  } = props;

  return (
    <Modal
      transitionName={transition ? undefined : ''}
      maskTransitionName={transition ? undefined : ''}
      onCancel={onClose}
      width="100%"
      footer={
        <ModalFooter>
          <Flex justify="end" align="center" gap="small">
            {footer}
          </Flex>
        </ModalFooter>
      }
      afterOpenChange={afterOpenChange}
    >
      <ModalHeader>
        <ModalTitle>{actions}</ModalTitle>
      </ModalHeader>
      {!readOnly && <FormAlerts />}
      <Container>{children}</Container>
    </Modal>
  );
};

const Container = styled.div`
  height: calc(100vh - 160px);
`;
